<template>
  <div class="user-dashboard-wrapper">
    <h1 class="heading squiggly-line-color" v-html="welcomeTitle"></h1>
    <!--<h4 class="mt-5">What would you like to learn today?</h4>-->
    <!--<div class="filter-area">-->
    <!--<div class="search">-->
    <!--<b-form-input-->
    <!--list="input-list"-->
    <!--id="input-with-list"-->
    <!--placeholder="What do you want to learn"-->
    <!--&gt;</b-form-input>-->
    <!--<b-form-datalist id="input-list" :options="options"></b-form-datalist>-->
    <!--</div>-->
    <!--<div class="subject">-->
    <!--<v-select-->
    <!--placeholder="Syllabus"-->
    <!--:options="['Physics', 'Mathematics', 'Biology']"-->
    <!--&gt;</v-select>-->
    <!--</div>-->
    <!--<div class="classes">-->
    <!--<v-select placeholder="10th" :options="['9', '8', '7']"></v-select>-->
    <!--</div>-->
    <!--<b-button variant="primary">Find my course</b-button>-->
    <!--</div>-->
    <div class="d-flex">
      <h4
        class="mt-5"
        v-if="getSubscribedCourses && getSubscribedCourses.length > 0"
      >
        Your Courses
      </h4>
      <!--<p class="see-all " v-if="getUserDetails.subscribed_courses.length > 4">-->
      <!--<b-link to="/student/my_courses">See All </b-link>-->
      <!--</p>-->
    </div>
    <div class="subscribed-courses" v-if="role === 'student'">
      <b-row v-if="getSubscribedCourses && getSubscribedCourses.length > 0">
        <b-col cols="12" md="6" lg="3" v-for="i in 4" :key="i">
          <course-template
            v-if="getSubscribedCourses[i - 1]"
            :courseData="getSubscribedCourses[i - 1]"
          />
        </b-col>
      </b-row>
      <!--<b-row v-else>-->
      <!--<b-col cols="3" v-for="i in 3" :key="i">-->
      <!--<ContentLoader :height="450" class="course-card"> </ContentLoader>-->
      <!--</b-col>-->
      <!--</b-row>-->
    </div>
    <h4 class="mt-5">Recommended Courses</h4>
    <div class="recommended-courses" :class="mostPopular ? 'slider-fade' : ''">
      <div class="tab-wrapper">
        <div class="tab-controls">
          <div class="tab-lg-controls">
            <b-tabs content-class="mt-3">
              <category-tabs
                :tabTitle="mostPopular"
                :isActive="booleanValue"
                :isACategory="!booleanValue"
              />
              <category-tabs
                      v-for="(category, i) in categoryData"
                :key="category.category_id"
                :tabTitle="category.name"
                :isActive="!booleanValue"
                :is-a-category="booleanValue"
                :categoryId="category.category_id"
              />
              <b-tab class="p-0">
                <template slot="title" v-if="hiddenCategoryData.length > 0">
                  <b-link
                          class="moredrop"
                  >
                    <b-dropdown id="dropdown-1" no-caret right>
                      <template v-slot:button-content>
                        <font-awesome-icon
                                icon="ellipsis-h"
                        ></font-awesome-icon>
                      </template>
                      <b-dropdown-item  v-for="(category, i) in hiddenCategoryData" :key="i"
                                        @click.prevent.stop="openTabDropdown(category,i)">{{ category.name}}</b-dropdown-item>
                    </b-dropdown>
                  </b-link>
                </template>
                <p>More</p>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <h4
      class="mt-5"
      v-if="
        liveCourses.todayLiveCourses && liveCourses.todayLiveCourses.length > 0
      "
    >
      Upcoming live courses
    </h4>
    <div
      v-if="
        liveCourses.todayLiveCourses && liveCourses.todayLiveCourses.length > 0
      "
      class="upcoming-live mt-3"
      :class="
        liveCourses.todayLiveCourses && liveCourses.todayLiveCourses.length > 3
          ? 'slider-fade'
          : ''
      "
    >
      <div class="live-tab">
        <banner-slider
          :slides="3"
          :liveCourses="liveCourses.todayLiveCourses"
        />
      </div>
    </div>
    <!--<div class="upcoming-live-footer">-->
    <!--<p>-->
    <!--Need help to find your course? or any other questions?-->
    <!--</p>-->
    <!--<b-button size="lg" pill variant="primary">-->
    <!--<span>Talk with an expert</span>-->
    <!--<font-awesome-icon icon="arrow-right" size="xs" />-->
    <!--</b-button>-->
    <!--</div>-->
    <landingteacher :teacherArray="teacherArray" v-if="role === 'student'" />
  </div>
</template>

<script>
import CourseTemplate from "../components/Templates/CourseTemplate";
import { store } from "../store/store";
import { mapGetters } from "vuex";
import CategoryTabs from "../components/Templates/categoryTabs";
import BannerSlider from "../components/Templates/BannerSlider";
import Landingteacher from "../components/Landing/LandingTeacher";
import { videoApi } from "../services/videoApi";
import { teacherApi } from "../services/teacherApi";
import { ContentLoader } from "vue-content-loader";
import { customerApi } from "../services/customerApi";

export default {
  components: {
    Landingteacher,
    BannerSlider,
    CategoryTabs,
    CourseTemplate,
    ContentLoader
  },
  data() {
    return {
      options: ["Apple", "Banana", "Grape", "Kiwi", "Orange"],
      mostPopular: "Most Popular",
      booleanValue: true,
      imageArray: ["img/live1bg.png", "img/live2bg.png", "img/live3bg.png"],
      welcomeTitle: "",
      role: "",
      isRegister: false,
      liveCourses: [],
      teacherArray: [],
        tabLength:4,
        categoryData: [],
        hiddenCategoryData: [],
    };
  },
  computed: {
    ...mapGetters("user", [
        "getUserRole",
      "getUserDetails",
      "getSubscribedCourses",
      "getSubscribedLiveCourses",
      "getTeacherCourses",
      "getTeacherLiveCourses"
    ]),
    ...mapGetters("category", ["getCategoryData"]),
    ...mapGetters("teacher", ["getAllTeachers", "getFollowingTeachers"])
  },
  methods: {
    setTitle() {
      if (this.isRegister) {
        this.welcomeTitle = `How's Day ${
          this.getUserDetails.name
        },<br> Welcome to Live Learning Hub`;
      } else {
        this.welcomeTitle = `Welcome Back ${this.getUserDetails.name}`;
      }
    },
    getLiveCourse() {
      videoApi.getAllLiveCourses().then(res => {
        this.liveCourses = res.data.liveCourseResponse;
      });
    },
    getAllTeacher() {
      teacherApi.getAllTeachers().then(res => {
        res.data.forEach(teacher => {
          if (
            this.getFollowingTeachers.some(
              teacherD => teacherD.teacher_id === teacher.teacher_id
            )
          ) {
            teacher.isFollowing = true;
          } else {
            teacher.isFollowing = false;
          }
          this.teacherArray.push(teacher);
        });
        store.dispatch("teacher/setAllTeachers", this.teacherArray);
      });
    },
      responsiveness() {
          if (screen.width > 1200) {
              this.tabLength = 3;
          } else if (screen.width > 992) {
              this.tabLength = 2;
          } else if (screen.width > 768) {
              this.tabLength = 2;
          } else {
              this.tabLength = 1;
          }
      },
      openTabDropdown(category,i) {
          this.categoryData.push(category);
          this.hiddenCategoryData.splice(i,1);
          this.hiddenCategoryData.push(this.categoryData[0]);
          this.categoryData.splice(0,1);
      },
      setCategoryArray(){
          this.getCategoryData.forEach( (category,i) => {
              if(i <= this.tabLength) this.categoryData.push(category);
              else this.hiddenCategoryData.push(category);
          });
      }
  },
  beforeMount() {
    this.role = this.$route.query.role;
    this.isRegister = this.$route.query.isRegister;
    this.setTitle();
      this.responsiveness();
      let self = this;
      window.onresize = function(event) {
          self.responsiveness();
      };
  },
  mounted() {
    this.getLiveCourse();
    this.getAllTeacher();
    customerApi.getSubscribedCourses(this.getUserRole);
    this.setCategoryArray()
  },
  watch: {
    getUserDetails() {
      this.setTitle();
    }
  }
};
</script>

<style></style>
